/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bsu'
export default icon
